export default {
  rateSheetDefinitions: [],
  rateSheetDefinitionsLoading: false,
  versionedRateSheetDefinitions: [],
  versionedRateSheetDefinitionsLoading: false
}
